import { DeviceBrowserCode } from '../types/deviceAndBrowser';

/**
 * ユーザーエージェントからデバイスとブラウザの組み合わせコードを取得
 * @returns デバイスとブラウザの組み合わせコード
 */
export const detectDeviceAndBrowser = (): DeviceBrowserCode => {
  const userAgent = navigator.userAgent.toLowerCase();

  // OSの判定
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  const isMobile = /iphone|ipad|ipod|android|mobile/.test(userAgent);

  // ブラウザの判定
  const isChrome = /chrome|crios/.test(userAgent) && !/edge|edg/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !/chrome|crios/.test(userAgent);
  const isEdge = /edge|edg/.test(userAgent);

  // デバイス・ブラウザの組み合わせコードを決定
  if (isMobile) {
    if (isIOS) {
      if (isChrome) return DeviceBrowserCode.IOS_CHROME;
      else if (isSafari) return DeviceBrowserCode.IOS_SAFARI;
      else return DeviceBrowserCode.MOBILE_OTHER;
    } else if (isAndroid) {
      if (isChrome) return DeviceBrowserCode.ANDROID_CHROME;
      else if (isSafari) return DeviceBrowserCode.ANDROID_SAFARI;
      else return DeviceBrowserCode.MOBILE_OTHER;
    } else {
      return DeviceBrowserCode.MOBILE_OTHER;
    }
  } else {
    // PCの場合
    if (isChrome) return DeviceBrowserCode.PC_CHROME;
    else if (isSafari) return DeviceBrowserCode.PC_SAFARI;
    else if (isEdge) return DeviceBrowserCode.PC_EDGE;
    else return DeviceBrowserCode.PC_OTHER;
  }
};

/** ログ・API 送信用の識別子文字列（数値 enum の逆引き） */
export const getDeviceBrowserLabel = (code: DeviceBrowserCode): string =>
  DeviceBrowserCode[code] ?? 'OTHER';

/**
 * デバイスとブラウザの組み合わせコードを取得するカスタムフック
 * @returns デバイスとブラウザの組み合わせコード
 */
// export const useDeviceDetection = (): number => {
//   const [deviceBrowserCode, setDeviceBrowserCode] = useState<number>(OTHER);

//   useEffect(() => {
//     setDeviceBrowserCode(detectDeviceAndBrowser());
//   }, []);

//   return deviceBrowserCode;
// };
